import styled from 'src/styles/theme';
import { ModalFeaturesStyled } from '../ModalFeaturesStyled';
import { rem } from 'polished';

export const ModalFeaturesStyledAP = styled(ModalFeaturesStyled)`
    .engines,
    .colors,
    .interiors,
    .features {
        .label {
            .compareLink {
                font-weight: normal;
                &:hover {
                    .link {
                        border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
                    }
                }

                svg {
                    margin-left: ${rem(6)};
                }
            }
        }
    }
`;
